// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.layered {
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.layered-no-overlap {
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.no-gutter > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.artful-checkbox-wrapper {
  position: relative;
  padding-left: 1.5em;
  min-height: 1.5em;
}
.artful-checkbox-wrapper + .artful-checkbox-wrapper {
  margin-top: 0.5em;
}
.artful-checkbox-wrapper input[type=checkbox] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.artful-checkbox-wrapper input[type=checkbox]:focus + label {
  outline: 2px auto -webkit-focus-ring-color;
  outline-offset: 2px;
}
.artful-checkbox-wrapper label {
  cursor: pointer;
  margin: 0;
  font-weight: 300;
}
.artful-checkbox-wrapper label::before {
  position: absolute;
  left: 0;
  top: 0.125em;
  content: "\\f058";
  font: normal normal normal 14px/1 FontAwesome;
  color: #cacacb;
  font-size: 1.2em;
}
.artful-checkbox-wrapper .small {
  font-size: 1.2rem;
}
.artful-checkbox-wrapper label.checked::before {
  color: #dabc64;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Form/ArtfulCheckbox.scss","webpack://./src/Styles/Material.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gBAAA;EACA,eAAA;ADKF;;AAXA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;AAcF;AAZE;EACE,iBAAA;AAcJ;AAXE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAaJ;AAVE;EACE,0CAAA;EACA,mBAAA;AAYJ;AATE;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AAWJ;AARE;EACE,kBAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,cDhCa;ECiCb,gBAAA;AAUJ;AARE;EACE,iBAAA;AAUJ;AAPE;EACE,cD1BG;ACmCP","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Variables.scss';\n@import 'Colors.scss';\n@import 'Material.scss';\n\n.artful-checkbox-wrapper {\n  position: relative;\n  padding-left: 1.5em;\n  min-height: 1.5em;\n\n  & + .artful-checkbox-wrapper {\n    margin-top: 0.5em;\n  }\n\n  input[type='checkbox'] {\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n  }\n\n  input[type='checkbox']:focus + label {\n    outline: 2px auto -webkit-focus-ring-color;\n    outline-offset: 2px;\n  }\n\n  label {\n    cursor: pointer;\n    margin: 0;\n    font-weight: 300;\n  }\n\n  label::before {\n    position: absolute;\n    left: 0;\n    top: 0.125em;\n    content: '\\f058';\n    font: normal normal normal 14px/1 FontAwesome;\n    color: $lightTextColor;\n    font-size: 1.2em;\n  }\n  .small {\n    font-size: 1.2rem;\n  }\n\n  label.checked::before {\n    color: $gold;\n  }\n}\n",".layered {\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.layered-no-overlap {\n  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.no-gutter > [class*='col-'] {\n  padding-right: 0;\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
